import React, { useEffect, useState } from 'react';
import { inquiryApi } from '../services/api';
import { Trash2, Mail, Phone } from 'lucide-react';
import toast from 'react-hot-toast';

const STATUS_TABS = ['all', 'unread', 'read', 'replied'];

export default function AdminInquiries() {
  const [inquiries, setInquiries] = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [tab,       setTab]       = useState('all');
  const [detail,    setDetail]    = useState(null);

  const load = async () => {
    setLoading(true);
    const res = await inquiryApi.getAll();
    setInquiries(res.data);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    await inquiryApi.updateStatus(id, status);
    load();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this inquiry?')) return;
    await inquiryApi.delete(id);
    toast.success('Inquiry deleted');
    setDetail(null);
    load();
  };

  const filtered = tab === 'all' ? inquiries : inquiries.filter((i) => i.status === tab);

  return (
    <div className="admin-page">
      <h1 className="admin-page-title">Inquiries</h1>

      {/* Tabs */}
      <div className="tab-bar">
        {STATUS_TABS.map((t) => (
          <button
            key={t}
            className={`tab-btn${tab === t ? ' active' : ''}`}
            onClick={() => setTab(t)}
          >
            {t.charAt(0).toUpperCase() + t.slice(1)}
            {t === 'unread' && (
              <span className="tab-badge">{inquiries.filter((i) => i.status === 'unread').length}</span>
            )}
          </button>
        ))}
      </div>

      {loading ? <div className="spinner"/> : (
        <div className="inquiries-list">
          {filtered.map((inq) => (
            <div
              key={inq.id}
              className={`inquiry-card${inq.status === 'unread' ? ' unread' : ''}`}
              onClick={() => { setDetail(inq); if (inq.status === 'unread') setStatus(inq.id, 'read'); }}
            >
              <div className="inquiry-header">
                <span className="inquiry-name">{inq.name}</span>
                <span className={`status-badge status-${inq.status === 'unread' ? 'pending' : 'confirmed'}`}>
                  {inq.status}
                </span>
                <span className="inquiry-date">
                  {new Date(inq.createdAt).toLocaleDateString('en-IN')}
                </span>
              </div>
              <p className="inquiry-subject">{inq.subject}</p>
              <p className="inquiry-preview">{inq.message.slice(0, 100)}…</p>
            </div>
          ))}
          {filtered.length === 0 && <p className="empty-state">No inquiries in this category.</p>}
        </div>
      )}

      {/* Detail Modal */}
      {detail && (
        <div className="modal-overlay" onClick={() => setDetail(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>{detail.subject}</h2>
            <div className="inquiry-meta">
              <span><Mail size={16}/> {detail.email}</span>
              {detail.phone && <span><Phone size={16}/> {detail.phone}</span>}
              <span>{new Date(detail.createdAt).toLocaleString('en-IN')}</span>
            </div>
            <p className="inquiry-full-message">{detail.message}</p>

            <div className="modal-actions">
              <button className="btn btn-ghost" onClick={() => setDetail(null)}>Close</button>
              <button className="btn btn-outline"
                onClick={() => { setStatus(detail.id, 'replied'); setDetail(null); }}>
                Mark Replied
              </button>
              <button className="btn btn-danger" onClick={() => handleDelete(detail.id)}>
                <Trash2 size={16}/> Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
